import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TravelerFormQuestionContainer from '../../base/TravelerFormQuestionContainer';
import TextInput from '../../base/inputs/TextInput';
import userId from '../../../../../shared/helpers/userId';
import { addIntakeQuestions, addAdminIntakeFormData } from '../../../actions/intakeFormActions';
import useMediaQuery from '../../../../../hooks/useMediaQuery';
export default function IntakePreferredPronouns(props) {
  const dispatch = useDispatch();
  const { isMobile, isDesktop, isTablet } = useMediaQuery();
  const intake = useSelector(state => state.intakeForm);
  const adminIntakeFormData = intake.adminIntakeFormData;
  const [value, setValue] = useState("");
  const [error, setError] = useState('');
  const [disabled, setDisabled] = useState(false);

  const question = {
    overline: 'Preferred Pronouns',
    heading: 'What pronouns do you use?',
    subheading: 'Enter your preferred pronouns.',
    isRequired: intake?.intakeQuestions?.find(item=>item.identifier=="preferred_pronouns").required ?? false,
  };

  useEffect(
    () => {
      if(props?.isAdmin) {
        setValue(adminIntakeFormData?.pronoun);
      } else {
        setValue(intake.pronoun);
      }
      setDisabled(intake.ssoTraveler && intake.readonly.includes('pronoun'));
    },
    [intake, adminIntakeFormData],
  );

  const handleNext = () => {
    
    setError("");
    if (!disabled && !value && question.isRequired) {
      setTimeout(()=>{
        setError('Required, please enter your preferred pronouns');
      },0) 
      if(props.isAdmin) {
        return;
      }
      throw new Error();
    }
    if(props.isAdmin) {
      dispatch(addAdminIntakeFormData( "pronoun", value));
      props.handleAdminStep();
      return;
    }
    if (!disabled) {
       dispatch(addIntakeQuestions(userId, { pronoun: value }, "pronoun"));
    }
  };

  const customInputStyle = {
    display: "flex",
    padding: "6px 12px",
    alignItems: "center",
    flex: "1 0 0",
    borderRadius: "4px",
    border: "1px solid var(--Gray-400, #CED4DA)",
    background: disabled ? "#eeeeee" : "var(--Gray-White, #FFF)",
  }
  const customInputContainerStyle = {
    width : isDesktop ? "100%" : "100%",
    marginTop:"1.375rem",
  }

  return (
    <TravelerFormQuestionContainer 
      handleBackStep={()=>props.handleAdminBackStep()} 
      adminIntakeStep={props.adminIntakeStep}
      isAdmin={props.isAdmin} 
      question={question} 
      handleNext={handleNext} 
      disabled={disabled} canBeSynced>
      <TextInput
        value={value}
        id="preferred_pronouns"
        label="Pronouns"
        placeholder="Enter pronouns"
        error={error}
        disabled={disabled}
        required ={question.isRequired}
        handleOnChange={event => {
          setValue(event.target.value);
        }}
        customInputStyle = {customInputStyle}
        customInputContainerStyle = {customInputContainerStyle}
      />
    </TravelerFormQuestionContainer>
  );
}
